import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'btntool',
    templateUrl: 'btntool.component.html',
    styleUrls: ['btntool.component.scss'],
})
export class BtnToolComponent implements OnInit {
    @Input() public btnTool;
    @Output() public clickButton = new EventEmitter<any>();

    public ngOnInit() {}

    public onClickButton() {
        this.clickButton.emit(this.btnTool);
    }
}
